import {getNodeLayers, type TreeNodeWithPage} from './diff-grouping.ts';
import type {SchemaType} from '../../../features/allspicejson';

export const VISIBILITY = {
  NONE: 'none',
  PARTIAL: 'partial',
  TOTAL: 'total',
} as const;
export function determineVisibility(visibleLayerIds: number[], item: TreeNodeWithPage, groupName: string, schemaType: SchemaType, diffTree: TreeNodeWithPage) {
  const itemLayerIds = getNodeLayers(
    schemaType,
    item,
    groupName,
    diffTree,
  );
  const visibleItemLayerIds = itemLayerIds.filter((layerId) => visibleLayerIds.includes(layerId));

  if (visibleItemLayerIds.length === 0) {
    return VISIBILITY.NONE;
  } else if (visibleItemLayerIds.length < itemLayerIds.length) {
    return VISIBILITY.PARTIAL;
  }
  return VISIBILITY.TOTAL;
}
